import { render, staticRenderFns } from "./FormCardWrapper.vue?vue&type=template&id=161bb44b&scoped=true&"
import script from "./FormCardWrapper.vue?vue&type=script&lang=js&"
export * from "./FormCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormCardWrapper.vue?vue&type=style&index=0&id=161bb44b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bb44b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161bb44b')) {
      api.createRecord('161bb44b', component.options)
    } else {
      api.reload('161bb44b', component.options)
    }
    module.hot.accept("./FormCardWrapper.vue?vue&type=template&id=161bb44b&scoped=true&", function () {
      api.rerender('161bb44b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormCardWrapper.vue"
export default component.exports